import React from 'react';
import { toast as toastify } from 'react-toastify';
import { isFunction } from 'lib';

export const toast = ({
  title = '',
  description = '',
  action = '',
  renderAction,
  type = 'success',
  ...rest
} = {}) => {
  toastify(
    ({ closeToast, toastProps }) => (
      <div
        className={`custom-toast ${type}`}
        data-testid={`applied-action-${type}`}
      >
        {title && <h4 className='m-0 mb-5'>{title}</h4>}
        {description && <p className='m-0'>{description}</p>}
        {action}
        {isFunction(renderAction)
          ? renderAction({ closeToast, toastProps })
          : undefined}
      </div>
    ),
    {
      type,
      ...rest,
    }
  );
};
